(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-bomben.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-bomben.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.tipset.views.BetslipBomben = Backbone.Marionette.View.extend({
    log: new svs.core.log.Logger('svs.tipset.views.BetslipBomben'),

    events: {
      'click .js-remove-bomben-bet': 'removeBombenBet'
    },

    modelEvents: {
      bombenSet: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.betslipbomben(data);
    },

    initialize: function() {
      this.log.debug('initialize');
    },

    removeBombenBet: function() {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Vill du ta bort ditt Bomben-spel?',
        actions: [
          {
            title: 'Avbryt'
          },
          {
            title: 'Ta bort',
            callback: function() {
              svs.components.dialog.api.close();
              svs.tipset.models.bombenXperten.reset();
            }
          }
        ]
      }));
    }
  });
})(svs);

 })(window);